export default {
  SET_OPEN_MODAL(state, payload) {
    state.showModalPatchNotes = payload;
  },
  SET_PATCH_NOTES(state, payload) {
    state.patchNotes = payload;
  },
};
